import { render, staticRenderFns } from "./TransactionButton.vue?vue&type=template&id=3e46b0a9"
import script from "./TransactionButton.vue?vue&type=script&lang=js"
export * from "./TransactionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports